import React from 'react'
import { Link } from 'react-router-dom'

function CardCate({data}) {
  return (
    <Link
      to={`/categories/${data.id}`}
      className='cardcart group flex flex-col mr-4 my-3 bg-white rounded-2xl shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-300 overflow-hidden border border-gray-100 animate-scale-in'
      style={{width: '280px'}}
    >
      <div className="relative overflow-hidden bg-gradient-primary h-32">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent"></div>
        </div>
        <div className="relative h-full flex items-center justify-center">
          <i className="fa fa-trophy text-white text-5xl opacity-30 group-hover:scale-110 transition-transform duration-500"></i>
        </div>
      </div>

      <div className="flex flex-col py-5 px-4">
        <h3 className='font-bold text-lg text-dark-800 group-hover:text-primary-600 transition-colors duration-300'>
          {data.name}
        </h3>
        <div className="flex items-center gap-2 mt-2 text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="text-sm font-semibold">View Category</span>
          <i className="fa fa-arrow-right text-sm"></i>
        </div>
      </div>
    </Link>
  )
}

export default CardCate